// const BASE_URL = "https://api.sportsrecsys.xyz"; // Change this if backend is deployed elsewhere
const BASE_URL = "http://127.0.0.1:5000"; // Change this if backend is deployed elsewhere

// Fetch next user ID from Flask API
export async function getNextUserId() {
  try {
    const response = await fetch(`${BASE_URL}/get_next_user_id`);
    const data = await response.json();
    return data.user_id;
  } catch (error) {
    console.error("Error fetching next user ID:", error);
    throw error;
  }
}

export async function saveUser(user_id, radioValues, numberValues, checkboxValues, otherLabels) {
  try {
    const response = await fetch(`${BASE_URL}/save_user`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ user_id, radioValues, numberValues, checkboxValues, otherLabels }),
    });

    const data = await response.json();
    console.log("User saved:", data.message); // Debugging log
  } catch (error) {
    console.error("Error saving user:", error);
  }
}

export async function saveRecommendations(user_id, recommendations) {
  try {
    const response = await fetch(`${BASE_URL}/save_recommendations`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ user_id, recommendations }),
    });

    const data = await response.json();
    console.log("Recommendations saved:", data.message); // Debugging log
  } catch (error) {
    console.error("Error saving recommendations:", error);
  }
}

export async function saveRating(user_id, itemId, itemName, ratingValue) {
  try {
    const response = await fetch(`${BASE_URL}/save_rating`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ user_id, itemId, itemName, ratingValue }),
    });

    const data = await response.json();
    console.log("Rating saved:", data.message); // Debugging log
  } catch (error) {
    console.error("Error saving rating:", error);
  }
}

export async function saveFeedback(user_id, feedback) {
  try {
    const response = await fetch(`${BASE_URL}/save_feedback`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ user_id, feedback }),
    });

    const data = await response.json();
    console.log("Feedback saved:", data.message); // Debugging log
  } catch (error) {
    console.error("Error saving feedback:", error);
  }
}

export async function saveSatisfaction(user_id, satisfaction) {
  try {
    const response = await fetch(`${BASE_URL}/save_satisfaction`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ user_id, satisfaction }),
    });

    const data = await response.json();
    console.log("Satisfaction saved:", data.message); // Debugging log
  } catch (error) {
    console.error("Error saving satisfaction:", error);
  }
}
